var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exchange",
    d: "m128 92c0 2.211-1.791 4-4 4h-110.344l17.172 17.172c1.563 1.563 1.563 4.094 0 5.656-.781.781-1.805 1.172-2.828 1.172s-2.047-.391-2.828-1.172l-24-24c-1.563-1.563-1.563-4.094 0-5.656l24-24c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-17.172 17.172h110.344c2.209 0 4 1.789 4 4zm-1.172-58.828-24-24c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l17.172 17.172h-110.344c-2.209 0-4 1.789-4 4s1.791 4 4 4h110.344l-17.172 17.172c-1.563 1.563-1.563 4.094 0 5.656.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l24-24c1.563-1.562 1.563-4.094 0-5.656z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwitch);
export default __webpack_public_path__ + "static/media/icon-switch.7bb1edad26a2da4db2d787f2a7c84249.svg";
export { ForwardRef as ReactComponent };